/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceTypeEnum } from './resourceTypeEnum';


/**
 * IRR SaaS Config Capabilities Section
 */
export interface IrrSaasCapabilities { 
    /**
     * VLR On Prem.
     */
    vlrOnPrem?: boolean;
    /**
     * VLR On Cloud.
     */
    vlrCloud?: boolean;
    /**
     * VMCFS On Cloud.
     */
    vmcfsCloud?: boolean;
    sddcVmcTypes?: Array<ResourceTypeEnum>;
    sddcGcveTypes?: Array<ResourceTypeEnum>;
    sddcEvsTypes?: Array<ResourceTypeEnum>;
    edrCarbonBlack?: Array<ResourceTypeEnum>;
    edrCrowdStrike?: Array<ResourceTypeEnum>;
    /**
     * EDR CrowdStrike Files
     */
    edrCrowdStrikeFiles?: string;
    /**
     * EDR CrowdStrike Files
     */
    edrCarbonBlackFiles?: string;
    /**
     * EDR CB Ignore sensor versions
     */
    edrCarbonBlackIgnoreSensorVersions?: string;
}

